<script>
export default {
    name: "ReceiveDepositForm",

    data() {

        return {
            active: 0,
            activeClass: `bg-gray-100 border-l-2 border-r-2 border-t-2 border-gray-500 rounded-t-md z-10 -mb-1`,
            inActiveClass: `bg-gray-300 border-l border-r border-t`,
            patient: {},
            patientDeposits: [],
            showPatientDetails:false,
        };
    },

    computed: {

        totalAmount() {
            if(!this.patientDeposits.length) return 0;

            return this.patientDeposits.map(pD => parseFloat(pD.depositAmount))
                .reduce((sum, amt) => sum + amt);
        },

        totalAllocated() {
             if(!this.patientDeposits.length) return 0;

             return this.patientDeposits.map(pD => parseFloat(pD.amountAllocated))
                .reduce((sum, amt) => sum + amt);
        },

        totalUnallocated() {
             if(!this.patientDeposits.length) return 0;

             return this.patientDeposits.map(pD => parseFloat(pD.unAllocatedAmount))
                .reduce((sum, amt) => sum + amt);
        },
    },

    components: {

        "cash-deposit-form": () => import('./tabs/Cash.vue'),
        "bank-deposit-form": () => import('./tabs/BankDeposit.vue'),
        "direct-deposit-form": () => import('./tabs/DirectMpBank.vue'),
        
        "patient-details-modal": () => import('@/components/commons/patient/ViewPatientDetails.vue'),
    },

    mounted() {

        this.$root.loading = true;
        Promise.allSettled([ this.fetchPatient(), this.fetchDeposits(), ]).then(() => {
            this.$root.loading = false;
        }).catch(() => { this.$root.loading = false; });
    },

    methods: {

        fetchPatient() {

            return this.$http.get(`PatientRegistration/GetSpecificPatient?PatientID=${this.$route.params.patientID}`).then(response => {
                this.patient = response.data.length ? response.data[0] : {};
            }).catch(() => {});
        },

        fetchDeposits() {

            return this.$http.get(`Accounts/GetPatientDeposits?PatientId=${this.$route.params.patientID}&VisitNo=${this.$route.params.visitNO}`).then(response => {
                this.patientDeposits = response.data;
            }).catch(() => {});
        },

        printReceipt() {
            const queryString = `?PatientID=${this.patient.patienT_ID}&VisitNo=${this.$route.params.visitNO}`;

            window.open(`/billing/receipt-deposit/print${queryString}`, 
                '_blank', `ReceiptCash`, 
                "menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes");
        },

        printReceiptSingle(receiptNo) {
            const queryString = `?ReceiptNo=${receiptNo}&PatientID=${this.patient.patienT_ID}`;

            window.open(`/billing/receipt-deposit/print-single${queryString}`, 
                '_blank', `ReceiptCash`, 
                "menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes");
        },
    },
}
</script>
<template>
    <tail-base-layout>
        <template v-slot:content>
            <tail-card>
              <template v-slot:card-header>
                <div class="flex md:flex-row sm:flex-col">
                    <div class="flex-1">
                        <h5 class="font-medium">Receive Deposit</h5>
                    </div>
                    <div class="flex-1">
                          <router-link 
                            class="btn-sm text-xs btn-primary rounded" 
                            :to="{ name: patient.patienT_ID ? `billing.bill-patient.create` : ``, 
                                params: { patientID: patient.patienT_ID, visitNO: patient.visitNo }}">
                                    <i class="fa fa-hand-holding-usd"></i> Bill Patient
                          </router-link>
                      </div>
                    <div class="flex-1">
                        <router-link 
                            class="btn-sm bg-blue-600 text-white font-bold whitespace-no-wrap rounded text-xs" 
                            :to="{ name: patient.patienT_ID ? `billing.receipt-invoice.create`: ``,
                              params: { patientID: patient.patienT_ID, visitNO: patient.visitNo }}">
                                  <i class="fa fa-file-invoice-dollar"></i> Receipt / Invoice
                        </router-link>
                    </div>
                    <div class="flex-1">
                        <button 
                            class="btn-sm text-xs btn-info rounded-md" 
                            @click.prevent="!patient.patienT_ID ? `` : showPatientDetails=true">
                                <i class="fa fa-archive"></i> View Patient Details
                          </button>
                          <patient-details-modal 
                            :patient="patient" 
                            :showModal="showPatientDetails" 
                            @closeModal="showPatientDetails=false"
                          />
                      </div>
                </div>
              </template>
              <template v-slot:card-body>
                <div class="flex flex-wrap rounded border-2 border-green-500 sm:my-1">
                      <div class="w-full bg-green-500 p-tiny">
                          <h5 class="font-bold text-white text-sm">Patient Details</h5>
                      </div>
                      <div class="w-full flex flex-wrap max-h-8 overflow-auto" style="height:3rem">
                              <div class="md:w-1/5 sm:w-full p-tiny">
                                  <h5 
                                    class="font-bold text-sm">Name: 
                                        <span class="text-blue-700">{{ patient.names }}</span></h5>
                              </div>
                              <div class="md:w-1/12 sm:w-full p-tiny">
                                  <h5 
                                    class="font-bold text-sm">MRN No: 
                                        <span class="text-blue-700">{{ patient.patienT_ID }}</span></h5>
                              </div> <div class="md:w-1/12 sm:w-full p-tiny">
                                  <h5 
                                    class="font-bold text-sm">ID NO: 
                                        <span class="text-blue-700">{{ patient.nationalid }}</span></h5>
                              </div>
                              <div class="md:w-1/12 sm:w-full p-tiny">
                                  <h5 
                                    class="font-bold text-sm">IPFile NO: 
                                        <span class="text-blue-700">{{ patient.ipfileno }}</span></h5>
                              </div>
                              <div class="md:w-1/12 sm:w-full p-tiny">
                                  <h5 
                                    class="font-bold text-sm">OPFile NO: 
                                        <span class="text-blue-700">{{ patient.opfileno }}</span></h5>
                              </div>
                              <div class="md:w-1/6 sm:w-full p-tiny">
                                  <h5 
                                    class="font-bold text-sm">Status: 
                                        <span class="text-blue-700">
                                            {{ 
                                                patient.iS_IN_PATIENT == `True` ? `Inpatient` : `Outpatient` 
                                            }}
                                        </span></h5>
                              </div>
                              <div class="md:flex-1 sm:w-full p-tiny">
                                  <h5 
                                    class="font-bold text-sm">P Mode: 
                                        <span class="text-blue-700">
                                            {{ patient.pMode }}
                                        </span></h5>
                              </div>
                          </div>
                  </div>
                  <div class="flex flex-col overflow-auto" style="height:65vh;">
                        <ul class="w-full flex border-b-2 border-gray-500">
                            <li class="-mb-px mr-1">
                                <a href="javascript:void(0)" @click.prevent="active=0"
                                   class="btn-sm text-sm text-gray-900 rounded-t-md inline-block px-4 font-bold whitespace-no-wrap"
                                   :class="active == 0 ? activeClass : inActiveClass"
                                   >Cash Deposit</a>
                            </li>
                            <li class="-mb-px mr-1">
                                <a href="javascript:void(0)" @click.prevent="active=1"
                                  class="btn-sm text-sm text-gray-900 rounded-t-md inline-block px-4 font-bold whitespace-no-wrap"
                                  :class="active == 1 ? activeClass : inActiveClass"
                                >Bank Deposit</a>
                            </li><li class="-mb-px mr-1">
                                <a href="javascript:void(0)" @click.prevent="active=2"
                                  class="btn-sm text-sm text-gray-900 rounded-t-md inline-block px-4 font-bold whitespace-no-wrap"
                                  :class="active == 2 ? activeClass : inActiveClass"
                                >Direct MPesa/Bank Deposit</a>
                            </li>
                        </ul>
                        <div class="w-full mt-1" v-if="active==0">
                            <cash-deposit-form :patient="patient" @refresh="fetchDeposits"></cash-deposit-form>
                        </div>
                        <div class="w-full mt-1" v-if="active==1">
                            <bank-deposit-form :patient="patient" @refresh="fetchDeposits"></bank-deposit-form>
                        </div> 
                        <div class="w-full mt-1" v-if="active==2">
                            <direct-deposit-form :patient="patient" @refresh="fetchDeposits"></direct-deposit-form>
                        </div>
                        <div class="w-full overflow-auto">
                            <table class="table table-hover">
                                <thead class="text-sm text-white whitespace-no-wrap bg-blue-500">
                                    <tr class="w-full flex">
                                        <th class="p-tiny flex-1">Receipt No</th>
                                        <th class="p-tiny flex-1">Trx Date</th>
                                        <th class="p-tiny flex-1">Payment Type</th>
                                        <th class="p-tiny flex-1">User</th>
                                        <th class="p-tiny flex-1">Cancelled</th>
                                        <th class="p-tiny flex-1">Amount</th>
                                        <th class="p-tiny flex-1">Allocated</th>
                                        <th class="p-tiny flex-1">Un-allocated</th>
                                        <th class="p-tiny flex-1">Memo</th>
                                        <th class="p-tiny flex-1">Action</th>
                                    </tr>
                                </thead>
                                <tfoot class="text-sm bg-gray-300">
                                    <tr class="w-full flex">
                                        <th colspan="3" class="p-tiny flex-1">
                                            Total Amount: {{ totalAmount | numberFormat }}
                                        </th>
                                        <th colspan="3" class="p-tiny flex-1">
                                            Total Allocated: {{totalAllocated | numberFormat }}
                                        </th>
                                        <th colspan="3" class="p-tiny flex-1">
                                            Total Unallocated: {{ totalUnallocated | numberFormat }}
                                        </th>
                                        <th class="p-tiny flex-1">
                                            <button 
                                                @click.prevent="printReceipt"
                                                class="btn-sm btn-primary text-xs rounded">
                                                    <i class="fa fa-print"></i> Print All</button>
                                        </th>
                                    </tr>
                                </tfoot>
                                <tbody class="text-xs flex flex-col bg-gray-100 overflow-auto" style="max-height:40vh;">
                                    <tr class="w-full flex" v-for="(patientDeposit, idx) in patientDeposits" :key="idx">
                                        <td class="p-tiny flex-1">{{ patientDeposit.receiptNo }}</td>
                                        <td class="p-tiny flex-1">{{ patientDeposit.trxDate | dateFormat }}</td>
                                        <td class="p-tiny flex-1">{{ patientDeposit.paymentType }}</td>
                                        <td class="p-tiny flex-1">{{ patientDeposit.userName }}</td>
                                        <td class="p-tiny flex-1">{{ patientDeposit.cancelled ? `Cancelled` : `Not Cancelled` }}</td>
                                        <td class="p-tiny flex-1">{{ patientDeposit.depositAmount | numberFormat }}</td>
                                        <td class="p-tiny flex-1">{{ patientDeposit.amountAllocated | numberFormat }}</td>
                                        <td class="p-tiny flex-1">{{ patientDeposit.unAllocatedAmount | numberFormat }}</td>
                                        <td class="p-tiny flex-1">{{ patientDeposit.trxMemo || `-` }}</td>
                                        <td class="p-tiny flex-1">
                                            <button 
                                                @click.prevent="printReceiptSingle(patientDeposit.receiptNo)"
                                                class="btn-sm btn-primary text-xs rounded">
                                                    <i class="fa fa-print"></i> Print</button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                  </div>
              </template>
              <template v-slot:card-footer>
                  <div class="w-full text-right">
                      <router-link :to="{ name: `billing.patients.index`}" class="btn-sm btn-danger text-xs rounded"><i class="fa fa-caret-left"></i> Back</router-link>
                  </div>
              </template>
            </tail-card>
        </template>
    </tail-base-layout>
</template>
